import { render, staticRenderFns } from "./SubLicenses.vue?vue&type=template&id=d10bde08&scoped=true"
import script from "./SubLicenses.vue?vue&type=script&lang=js"
export * from "./SubLicenses.vue?vue&type=script&lang=js"
import style0 from "./SubLicenses.vue?vue&type=style&index=0&id=d10bde08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10bde08",
  null
  
)

/* custom blocks */
import block0 from "./SubLicenses.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports